import React, { Component } from "react";
import { connect } from "react-redux";
import { NAVIGATE } from "./types";

export const NavContainer = Navigation => {
    class NavContainer extends Component {
        constructor() {
            super();
            this.select = this.select.bind(this);
            this.selected = this.selected.bind(this);
        }

        componentWillMount() {
            //initial nav selection if navigation is required
            const {
                defaultSelection,
                selectionRequired,
                nav,
                view
            } = this.props;
            if (defaultSelection && !nav[view]) {
                this.props.navigate(defaultSelection, view);
            } else if (selectionRequired) {
                this.props.navigate(this.props.items[0].value, view);
            }
        }

        select(item) {
            this.props.navigate(item, this.props.view);
        }

        selected() {
            let { nav, view } = this.props;

            if (nav[view] && nav[view].selected) {
                return nav[view].selected;
            } else {
                return null;
            }
        }

        render() {
            let props = {
                selectItem: this.select,
                ...this.props
            };
            return <Navigation {...props} selected={this.selected()} />;
        }
    }

    const mapStateToProps = ({ navigation }) => {
        return {
            nav: navigation
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            navigate: (item, view) =>
                dispatch({ type: NAVIGATE, result: { view, item } })
        };
    };

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(NavContainer);
};
